import axiosServices from 'utils/axios';
import { GenericTableDataFileUploadDto, GenericTableDataFileUploadResponseDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';

export const uploadFile = async (
    data: GenericTableDataFileUploadDto,
): Promise<GenericTableDataFileUploadResponseDto> => {
    const form = new FormData();
    form.append('file', data.file);

    const res = await axiosServices.post<GenericTableDataFileUploadResponseDto>(
        InsideFifaBackOfficeEndpoints.GenericTables.Files,
        form,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        },
    );

    return res.data;
};
